/**
 * @generated SignedSource<<48534978ff306d92ceea802576854bf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomContentInput = {
  attribs?: CustomContentInputAttributes | null | undefined;
  row?: number | null | undefined;
  type: string;
};
export type CustomContentInputAttributes = {
  infiniteAdsAfterNumber?: string | null | undefined;
  percentage?: string | null | undefined;
  tag?: string | null | undefined;
};
export type sectionPageQuery$variables = {
  applicationId: string;
  articlesQueueName: string;
  commentHarrySectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  commentQueueLimit: number;
  commentQueueName: string;
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  dailyPulseTypeUuId: string;
  entityId: string;
  focusQueueName: string;
  highlightQueueName: string;
  includeAsiaDiscoveryWidget: boolean;
  includeChinaFutureTechDiscoveryWidget: boolean;
  includeChinaScienceDiscoveryWidget: boolean;
  includeComment: boolean;
  includeFocusArticle: boolean;
  includeMostPopular: boolean;
  includeMultimedia: boolean;
  includeOpenQuestionsSeriesDiscoveryWidget: boolean;
  includePlus: boolean;
  includeThisWeekInAsiaDiscovery: boolean;
  includeTrendingTopics: boolean;
  isPostMagazineSection: boolean;
  isSkipDefaultSectionQuery: boolean;
  isStyleSection: boolean;
  mostPopularQueueName: string;
  multimediaQueueName: string;
  plusNewsAgendaEndDate: number;
  plusNewsAgendaStartDate: number;
  plusNewsAgendaTypes: ReadonlyArray<string | null | undefined>;
  scmpPlusPaywallTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  sectionSpotlightQueueName: string;
  sponsorQueueName: string;
  trendingTopicsQueueName: string;
};
export type sectionPageQuery$data = {
  readonly section: {
    readonly entityId: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"contextsSectionContextProviderSection" | "hooksTrackCurrentItemBase" | "sectionSeoSection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"defaultSectionQuery" | "sectionPostMagazineQuery" | "sectionStyleContentQuery">;
};
export type sectionPageQuery = {
  response: sectionPageQuery$data;
  variables: sectionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "articlesQueueName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentHarrySectionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueLimit"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentQueueName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dailyPulseTypeUuId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "focusQueueName"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "highlightQueueName"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAsiaDiscoveryWidget"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaFutureTechDiscoveryWidget"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeChinaScienceDiscoveryWidget"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeComment"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFocusArticle"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMostPopular"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMultimedia"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOpenQuestionsSeriesDiscoveryWidget"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePlus"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeThisWeekInAsiaDiscovery"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTrendingTopics"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPostMagazineSection"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSkipDefaultSectionQuery"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isStyleSection"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostPopularQueueName"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "multimediaQueueName"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaEndDate"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaStartDate"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "plusNewsAgendaTypes"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scmpPlusPaywallTypeIds"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sectionSpotlightQueueName"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sponsorQueueName"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trendingTopicsQueueName"
},
v33 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v34 = [
  {
    "fields": [
      (v33/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v38 = {
  "kind": "Variable",
  "name": "customContents",
  "variableName": "customContents"
},
v39 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  (v38/*: any*/)
],
v40 = [
  (v35/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v40/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "kind": "InlineFragment",
  "selections": (v42/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentiment",
  "storageKey": null
},
v46 = [
  (v36/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v46/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = [
  {
    "defaultValue": "PARAGRAPH",
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v51 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "hooksUseNotificationsSection",
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "notificationSection",
        "selections": (v46/*: any*/),
        "args": null,
        "argumentDefinitions": ([]/*: any*/)
      },
      (v35/*: any*/)
    ],
    "args": null,
    "argumentDefinitions": ([]/*: any*/)
  }
],
v52 = {
  "kind": "InlineFragment",
  "selections": (v42/*: any*/),
  "type": "Article",
  "abstractKey": null
},
v53 = [
  (v35/*: any*/),
  (v36/*: any*/)
],
v54 = {
  "kind": "Variable",
  "name": "applicationId",
  "variableName": "applicationId"
},
v55 = {
  "kind": "Variable",
  "name": "articlesQueueName",
  "variableName": "articlesQueueName"
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v57 = [
  (v56/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v60 = [
  (v59/*: any*/)
],
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v63 = [
  (v35/*: any*/),
  (v62/*: any*/),
  (v36/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v68 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v72 = [
  (v36/*: any*/),
  (v35/*: any*/),
  (v62/*: any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v76 = [
  (v36/*: any*/),
  (v62/*: any*/)
],
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v67/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": (v60/*: any*/),
      "storageKey": null
    },
    (v62/*: any*/)
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v79/*: any*/)
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v48/*: any*/),
    (v62/*: any*/)
  ],
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v62/*: any*/)
  ],
  "storageKey": null
},
v83 = [
  (v35/*: any*/),
  (v62/*: any*/)
],
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v83/*: any*/),
  "storageKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v83/*: any*/),
      "storageKey": null
    },
    (v61/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v62/*: any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v83/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    (v81/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v88/*: any*/),
    (v90/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "QueueItemConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v36/*: any*/),
                (v44/*: any*/)
              ],
              "type": "Topic",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v36/*: any*/),
                (v44/*: any*/),
                (v82/*: any*/)
              ],
              "type": "Section",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v35/*: any*/),
                (v48/*: any*/),
                (v44/*: any*/),
                (v82/*: any*/),
                (v84/*: any*/),
                (v85/*: any*/),
                (v89/*: any*/),
                (v91/*: any*/)
              ],
              "type": "BaseWithApplicationAndUrlAlias",
              "abstractKey": "__isBaseWithApplicationAndUrlAlias"
            },
            (v92/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v95 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "TERM_LOGO"
    }
  }
],
v96 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "style": "100x100"
        }
      }
    ],
    "concreteType": "ImageStyle",
    "kind": "LinkedField",
    "name": "style",
    "plural": false,
    "selections": (v60/*: any*/),
    "storageKey": "style(filter:{\"style\":\"100x100\"})"
  }
],
v97 = {
  "alias": "sectionLogo",
  "args": (v95/*: any*/),
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v96/*: any*/),
  "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v99 = [
  (v98/*: any*/)
],
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v101 = [
  (v100/*: any*/)
],
v102 = {
  "kind": "InlineFragment",
  "selections": (v101/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v103 = {
  "kind": "InlineFragment",
  "selections": (v101/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v104 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "articlesQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v58/*: any*/),
    (v71/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v57/*: any*/),
      "storageKey": null
    },
    (v62/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v109 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "1200x800"
    }
  }
],
v110 = {
  "alias": "size1200x800",
  "args": (v109/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v111 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v112 = {
  "alias": "landscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v113 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    (v35/*: any*/),
    (v48/*: any*/),
    (v44/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v89/*: any*/),
    (v91/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v36/*: any*/),
        (v62/*: any*/),
        (v105/*: any*/),
        (v113/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v99/*: any*/),
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v98/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "kind": "InlineFragment",
  "selections": [
    (v86/*: any*/),
    (v87/*: any*/),
    (v41/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v118 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    (v90/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v117/*: any*/),
    (v118/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v99/*: any*/),
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v35/*: any*/),
        (v62/*: any*/),
        (v36/*: any*/),
        (v58/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v79/*: any*/),
    (v62/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v125 = {
  "kind": "InlineFragment",
  "selections": [
    (v81/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/),
    (v120/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        (v120/*: any*/),
        (v62/*: any*/),
        (v113/*: any*/)
      ],
      "storageKey": null
    },
    (v64/*: any*/),
    (v74/*: any*/),
    (v121/*: any*/),
    (v122/*: any*/),
    (v123/*: any*/),
    (v124/*: any*/),
    (v105/*: any*/),
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v127 = {
  "kind": "InlineFragment",
  "selections": [
    (v126/*: any*/),
    (v41/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v128 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "sectionSpotlightQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v129 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v130 = [
  (v129/*: any*/)
],
v131 = {
  "kind": "InlineFragment",
  "selections": (v40/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v132 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          (v131/*: any*/),
          (v92/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v133 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "commentQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v134 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentQueueLimit"
  }
],
v135 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    (v48/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v89/*: any*/),
    (v91/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v136 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v59/*: any*/),
    (v108/*: any*/),
    (v67/*: any*/),
    (v110/*: any*/),
    (v111/*: any*/)
  ],
  "storageKey": null
},
v137 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v138 = [
  (v137/*: any*/)
],
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    (v78/*: any*/),
    (v62/*: any*/)
  ],
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v76/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v36/*: any*/),
        (v35/*: any*/),
        (v58/*: any*/),
        (v62/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v142 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v52/*: any*/),
    (v118/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v143 = {
  "kind": "InlineFragment",
  "selections": [
    (v74/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/),
    (v64/*: any*/),
    (v141/*: any*/),
    (v124/*: any*/),
    (v142/*: any*/),
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v144 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v145 = [
  (v144/*: any*/)
],
v146 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "71"
    }
  }
],
v147 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    (v78/*: any*/),
    (v62/*: any*/),
    (v105/*: any*/),
    (v44/*: any*/),
    (v36/*: any*/),
    (v106/*: any*/),
    (v135/*: any*/)
  ],
  "storageKey": null
},
v148 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v44/*: any*/),
        (v147/*: any*/),
        (v107/*: any*/),
        (v70/*: any*/),
        (v69/*: any*/),
        (v73/*: any*/),
        (v65/*: any*/),
        (v136/*: any*/),
        (v66/*: any*/),
        (v75/*: any*/),
        (v114/*: any*/),
        (v115/*: any*/),
        (v116/*: any*/),
        (v77/*: any*/),
        (v119/*: any*/),
        (v125/*: any*/),
        (v127/*: any*/)
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v149 = [
  {
    "alias": null,
    "args": (v138/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v131/*: any*/),
              (v92/*: any*/),
              (v148/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:6)"
  },
  (v62/*: any*/)
],
v150 = [
  (v44/*: any*/),
  (v36/*: any*/),
  (v35/*: any*/),
  (v61/*: any*/),
  (v62/*: any*/)
],
v151 = [
  (v44/*: any*/),
  (v36/*: any*/),
  (v35/*: any*/),
  (v61/*: any*/),
  (v97/*: any*/),
  (v62/*: any*/)
],
v152 = [
  (v36/*: any*/),
  (v100/*: any*/)
],
v153 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "MAIN_IMAGE"
    }
  }
],
v154 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v155 = [
  (v154/*: any*/)
],
v156 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v96/*: any*/),
  "storageKey": null
},
v157 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "DESC",
    "field": "PUBLISHED_DATE"
  }
},
v158 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "wide_landscape"
    }
  }
],
v159 = {
  "alias": "size1280x720",
  "args": (v158/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
},
v160 = {
  "kind": "InlineFragment",
  "selections": [
    (v141/*: any*/),
    (v124/*: any*/),
    (v64/*: any*/),
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v161 = {
  "kind": "Literal",
  "name": "exclude",
  "value": {
    "types": "VIDEO"
  }
},
v162 = [
  (v161/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v163 = {
  "alias": "size500x500",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "500x500"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"500x500\"})"
},
v164 = [
  (v105/*: any*/)
],
v165 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      (v36/*: any*/),
                      (v48/*: any*/),
                      (v62/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v35/*: any*/),
                          (v44/*: any*/),
                          (v82/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v89/*: any*/),
                          (v91/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v59/*: any*/),
                      (v108/*: any*/),
                      (v67/*: any*/),
                      (v159/*: any*/),
                      (v163/*: any*/),
                      (v110/*: any*/),
                      {
                        "alias": "size1200x1200",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "1200x1200"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v60/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"1200x1200\"})"
                      },
                      (v111/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v66/*: any*/),
                  (v75/*: any*/),
                  (v140/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v35/*: any*/),
                      (v78/*: any*/),
                      (v62/*: any*/),
                      (v36/*: any*/),
                      (v106/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v48/*: any*/),
                          (v44/*: any*/),
                          (v82/*: any*/),
                          (v84/*: any*/),
                          (v85/*: any*/),
                          (v89/*: any*/),
                          (v91/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v35/*: any*/),
                      (v48/*: any*/),
                      (v44/*: any*/),
                      (v82/*: any*/),
                      (v84/*: any*/),
                      (v85/*: any*/),
                      (v117/*: any*/),
                      (v118/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v121/*: any*/),
                      (v141/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          (v79/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v44/*: any*/),
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": (v164/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegment",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v105/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v69/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v164/*: any*/),
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  (v127/*: any*/)
                ],
                "type": "Content",
                "abstractKey": "__isContent"
              }
            ],
            "type": "Article",
            "abstractKey": null
          },
          (v92/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v166 = [
  "exclude"
],
v167 = [
  {
    "alias": null,
    "args": (v162/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v165/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:3)"
  },
  {
    "alias": null,
    "args": (v162/*: any*/),
    "filters": (v166/*: any*/),
    "handle": "connection",
    "key": "sectionStyleMainArticleListQueue__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v62/*: any*/)
],
v168 = [
  (v36/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "type": {
            "values": [
              "logo"
            ]
          }
        }
      }
    ],
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "images",
    "plural": true,
    "selections": (v60/*: any*/),
    "storageKey": "images(filter:{\"type\":{\"values\":[\"logo\"]}})"
  },
  (v62/*: any*/),
  (v113/*: any*/)
],
v169 = [
  (v161/*: any*/),
  (v129/*: any*/)
],
v170 = [
  {
    "alias": null,
    "args": (v169/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v165/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:4)"
  },
  {
    "alias": null,
    "args": (v169/*: any*/),
    "filters": (v166/*: any*/),
    "handle": "connection",
    "key": "sectionStyleMainArticleListQueue__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v62/*: any*/)
],
v171 = {
  "kind": "InlineFragment",
  "selections": (v40/*: any*/),
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v172 = {
  "alias": "size800x1200",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "portrait"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"portrait\"})"
},
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v59/*: any*/),
    (v108/*: any*/),
    (v67/*: any*/),
    (v172/*: any*/)
  ],
  "storageKey": null
},
v174 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    (v78/*: any*/),
    (v62/*: any*/),
    (v44/*: any*/),
    (v36/*: any*/),
    (v106/*: any*/),
    (v135/*: any*/)
  ],
  "storageKey": null
},
v175 = {
  "kind": "InlineFragment",
  "selections": [
    (v48/*: any*/),
    (v44/*: any*/),
    (v82/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v89/*: any*/),
    (v91/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v176 = {
  "alias": "size768x768",
  "args": (v68/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v60/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v177 = {
  "kind": "InlineFragment",
  "selections": [
    (v64/*: any*/),
    (v141/*: any*/),
    (v124/*: any*/),
    (v43/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v34/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          (v36/*: any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hooksTrackCurrentItemBase",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v37/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentArticleAtomBase",
                    "selections": [
                      (v37/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v39/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "articleSeoArticle"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "contentShareWidgetContent"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "headerContentBookmarkArticle",
                            "selections": (v40/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "headerContentCommentTrigger",
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "articleCommentsTriggerArticle"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersCheckIsStyleArticle",
                            "selections": [
                              (v43/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersUseSharingUrl",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "articleShareWidgetArticle"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "hooksTrackPageViewArticle"
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksContentInterestArticle",
                            "selections": [
                              (v35/*: any*/),
                              (v45/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": (v46/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v47/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticleIdsArticle",
                            "selections": [
                              (v35/*: any*/),
                              (v48/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseCurrentArticlePrebidConfigArticle",
                            "selections": [
                              (v49/*: any*/),
                              (v47/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUsePageTargetingArticle",
                            "selections": [
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "firstTopic",
                                "plural": false,
                                "selections": (v46/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "hooksUseNotificationReadStatusArticle",
                            "selections": (v40/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "onboardingNewsletterSubscriptionArticle",
                            "selections": (v42/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "args": (v39/*: any*/),
                    "argumentDefinitions": (v50/*: any*/)
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentNotificationSectionAtomBase",
                    "selections": [
                      (v37/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v51/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegment",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": (v51/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentTakeoverAdSectionsAtomBase",
                    "selections": [
                      (v37/*: any*/),
                      (v52/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v40/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
                    "selections": [
                      (v37/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegment",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": (v53/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v53/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "args": [
              (v38/*: any*/)
            ],
            "argumentDefinitions": (v50/*: any*/)
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contextsSectionContextProviderSection"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "sectionSeoSection"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v54/*: any*/),
              (v55/*: any*/),
              {
                "kind": "Variable",
                "name": "commentHarrySectionIds",
                "variableName": "commentHarrySectionIds"
              },
              {
                "kind": "Variable",
                "name": "commentQueueLimit",
                "variableName": "commentQueueLimit"
              },
              {
                "kind": "Variable",
                "name": "commentQueueName",
                "variableName": "commentQueueName"
              },
              {
                "kind": "Variable",
                "name": "dailyPulseTypeUuId",
                "variableName": "dailyPulseTypeUuId"
              },
              (v33/*: any*/),
              {
                "kind": "Variable",
                "name": "focusQueueName",
                "variableName": "focusQueueName"
              },
              {
                "kind": "Variable",
                "name": "highlightQueueName",
                "variableName": "highlightQueueName"
              },
              {
                "kind": "Variable",
                "name": "includeAsiaDiscoveryWidget",
                "variableName": "includeAsiaDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeChinaFutureTechDiscoveryWidget",
                "variableName": "includeChinaFutureTechDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeChinaScienceDiscoveryWidget",
                "variableName": "includeChinaScienceDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includeComment",
                "variableName": "includeComment"
              },
              {
                "kind": "Variable",
                "name": "includeFocusArticle",
                "variableName": "includeFocusArticle"
              },
              {
                "kind": "Variable",
                "name": "includeMostPopular",
                "variableName": "includeMostPopular"
              },
              {
                "kind": "Variable",
                "name": "includeMultimedia",
                "variableName": "includeMultimedia"
              },
              {
                "kind": "Variable",
                "name": "includeOpenQuestionsSeriesDiscoveryWidget",
                "variableName": "includeOpenQuestionsSeriesDiscoveryWidget"
              },
              {
                "kind": "Variable",
                "name": "includePlus",
                "variableName": "includePlus"
              },
              {
                "kind": "Variable",
                "name": "includeThisWeekInAsiaDiscovery",
                "variableName": "includeThisWeekInAsiaDiscovery"
              },
              {
                "kind": "Variable",
                "name": "includeTrendingTopics",
                "variableName": "includeTrendingTopics"
              },
              {
                "kind": "Variable",
                "name": "mostPopularQueueName",
                "variableName": "mostPopularQueueName"
              },
              {
                "kind": "Variable",
                "name": "multimediaQueueName",
                "variableName": "multimediaQueueName"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaEndDate",
                "variableName": "plusNewsAgendaEndDate"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaStartDate",
                "variableName": "plusNewsAgendaStartDate"
              },
              {
                "kind": "Variable",
                "name": "plusNewsAgendaTypes",
                "variableName": "plusNewsAgendaTypes"
              },
              {
                "kind": "Variable",
                "name": "scmpPlusPaywallTypeIds",
                "variableName": "scmpPlusPaywallTypeIds"
              },
              {
                "kind": "Variable",
                "name": "sectionSpotlightQueueName",
                "variableName": "sectionSpotlightQueueName"
              },
              {
                "kind": "Variable",
                "name": "trendingTopicsQueueName",
                "variableName": "trendingTopicsQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "defaultSectionQuery"
          }
        ]
      },
      {
        "condition": "isStyleSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v55/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "sectionStyleContentQuery"
          }
        ]
      },
      {
        "condition": "isPostMagazineSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v55/*: any*/),
              (v33/*: any*/),
              {
                "kind": "Variable",
                "name": "sponsorQueueName",
                "variableName": "sponsorQueueName"
              }
            ],
            "kind": "FragmentSpread",
            "name": "sectionPostMagazineQuery"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v23/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v31/*: any*/),
      (v30/*: any*/),
      (v32/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Operation",
    "name": "sectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v34/*: any*/),
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "section",
        "plural": false,
        "selections": [
          (v35/*: any*/),
          (v36/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "version",
                "value": 2
              }
            ],
            "kind": "ScalarField",
            "name": "advertZone",
            "storageKey": "advertZone(version:2)"
          },
          (v58/*: any*/),
          (v48/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "OG"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v60/*: any*/),
            "storageKey": "image(filter:{\"type\":\"OG\"})"
          },
          (v61/*: any*/),
          (v44/*: any*/),
          (v62/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v37/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegment",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": (v63/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": (v63/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disableOffPlatformContent",
                    "storageKey": null
                  },
                  (v64/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "published",
                    "storageKey": null
                  },
                  (v65/*: any*/),
                  (v66/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": (v63/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      {
                        "alias": "generic_og",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "og_image_scmp_generic"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v60/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "styles": [
                                "og_postmag",
                                "og_image_style",
                                "og_image_scmp_analysis",
                                "og_image_scmp_explainer",
                                "og_image_scmp_editorial",
                                "og_image_scmp_fact_check",
                                "og_image_scmp_debate",
                                "og_image_scmp_live",
                                "og_image_scmp_obituary",
                                "og_image_scmp_opinion",
                                "og_image_scmp_review",
                                "og_image_scmp_series",
                                "og_image_scmp_generic"
                              ]
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "styles",
                        "plural": true,
                        "selections": [
                          (v59/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "style",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_debate\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                      },
                      (v67/*: any*/),
                      {
                        "alias": null,
                        "args": (v68/*: any*/),
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v60/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"768x768\"})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSlideshow",
                        "storageKey": null
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v71/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "subHeadline",
                    "plural": false,
                    "selections": (v57/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v38/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "PARAGRAPH"
                      }
                    ],
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": (v57/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "keywords",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": (v72/*: any*/),
                    "storageKey": null
                  },
                  (v73/*: any*/),
                  (v74/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleSpeech",
                    "kind": "LinkedField",
                    "name": "articleSpeeches",
                    "plural": true,
                    "selections": [
                      (v59/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gender",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "voiceName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v75/*: any*/),
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "firstTopic",
                    "plural": false,
                    "selections": (v76/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v77/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": [
                          (v78/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleTypeSegment",
                            "kind": "LinkedField",
                            "name": "types",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleType",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v58/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v80/*: any*/),
                          (v81/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "fullSectionPath",
                    "plural": true,
                    "selections": (v72/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "Section",
                "abstractKey": null
              }
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSkipDefaultSectionQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v34/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "subSections",
                "plural": false,
                "selections": [
                  (v93/*: any*/),
                  (v94/*: any*/),
                  (v62/*: any*/)
                ],
                "storageKey": null
              },
              (v97/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "description",
                "plural": false,
                "selections": (v99/*: any*/),
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v102/*: any*/),
                  (v103/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "topStories",
            "args": (v104/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 17
                  }
                ],
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v35/*: any*/),
                                  (v78/*: any*/),
                                  (v62/*: any*/),
                                  (v105/*: any*/),
                                  (v44/*: any*/),
                                  (v36/*: any*/),
                                  (v106/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v37/*: any*/),
                                      (v48/*: any*/),
                                      (v82/*: any*/),
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v89/*: any*/),
                                      (v91/*: any*/),
                                      (v102/*: any*/),
                                      (v103/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v107/*: any*/),
                              (v70/*: any*/),
                              (v69/*: any*/),
                              (v73/*: any*/),
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v59/*: any*/),
                                  (v108/*: any*/),
                                  (v67/*: any*/),
                                  (v110/*: any*/),
                                  (v111/*: any*/),
                                  (v112/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v114/*: any*/),
                              (v115/*: any*/),
                              (v116/*: any*/),
                              (v77/*: any*/),
                              (v119/*: any*/),
                              (v125/*: any*/),
                              (v127/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:17)"
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "spotlightQueue",
            "args": (v128/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v130/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v132/*: any*/),
                "storageKey": "items(first:4)"
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "commentQueue",
            "args": (v133/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v134/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": (v132/*: any*/),
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sectionSpotlightQueue",
            "args": (v128/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v130/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v35/*: any*/),
                                  (v78/*: any*/),
                                  (v62/*: any*/),
                                  (v44/*: any*/),
                                  (v36/*: any*/),
                                  (v106/*: any*/),
                                  (v105/*: any*/),
                                  (v135/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v107/*: any*/),
                              (v70/*: any*/),
                              (v69/*: any*/),
                              (v73/*: any*/),
                              (v65/*: any*/),
                              (v136/*: any*/),
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v114/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "summary",
                                "plural": false,
                                "selections": [
                                  (v56/*: any*/),
                                  (v98/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v115/*: any*/),
                              (v77/*: any*/),
                              (v119/*: any*/),
                              (v125/*: any*/),
                              (v127/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:4)"
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "postMagazineLast7Days",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "scmp_trending_section_scmp_trending_section_postmag_last_7_days"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v138/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  (v139/*: any*/),
                                  (v65/*: any*/),
                                  (v136/*: any*/),
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  (v140/*: any*/),
                                  (v71/*: any*/),
                                  (v73/*: any*/),
                                  (v143/*: any*/),
                                  (v142/*: any*/),
                                  (v127/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v62/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"})"
          },
          {
            "alias": "postMagazineSponsor",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "discovery_module_discovery_module_71"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v145/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v44/*: any*/),
                                  (v139/*: any*/),
                                  (v65/*: any*/),
                                  (v136/*: any*/),
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  (v140/*: any*/),
                                  (v71/*: any*/),
                                  (v73/*: any*/),
                                  (v143/*: any*/),
                                  (v142/*: any*/),
                                  (v127/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v62/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"discovery_module_discovery_module_71\"})"
          },
          {
            "alias": "postMagazineSection",
            "args": (v146/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v62/*: any*/),
              (v113/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          },
          {
            "condition": "includeAsiaDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "asiaQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_3"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v149/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_3\"})"
              },
              {
                "alias": "asiaSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "3"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v150/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"3\"})"
              }
            ]
          },
          {
            "condition": "includeChinaFutureTechDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "chinaFutureTechQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_519735"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v149/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_519735\"})"
              },
              {
                "alias": "chinaFutureTechSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "519735"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v151/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"519735\"})"
              }
            ]
          },
          {
            "condition": "includeChinaScienceDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "chinaScienceQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_328475"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v149/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_328475\"})"
              },
              {
                "alias": "chinaScienceSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "328475"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v150/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"328475\"})"
              }
            ]
          },
          {
            "condition": "includeThisWeekInAsiaDiscovery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "twiaQueue",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "name": "section_top_323045"
                    }
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v149/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_323045\"})"
              },
              {
                "alias": "twiaSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "323045"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": (v151/*: any*/),
                "storageKey": "section(filter:{\"entityId\":\"323045\"})"
              }
            ]
          },
          {
            "condition": "includeComment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "commentSection",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "93"
                    }
                  }
                ],
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v44/*: any*/),
                  (v62/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v37/*: any*/),
                      (v35/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v46/*: any*/),
                        "type": "Section",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v152/*: any*/),
                        "type": "Author",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v152/*: any*/),
                        "type": "Topic",
                        "abstractKey": null
                      }
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "storageKey": "section(filter:{\"entityId\":\"93\"})"
              },
              {
                "alias": "commentQueue",
                "args": (v133/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v134/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  (v107/*: any*/),
                                  (v70/*: any*/),
                                  (v69/*: any*/),
                                  (v73/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v35/*: any*/),
                                      (v48/*: any*/),
                                      (v36/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "type": "AUTHOR_IMAGE"
                                            }
                                          }
                                        ],
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                  "style": "300x300"
                                                }
                                              }
                                            ],
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v60/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"300x300\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                                      },
                                      (v62/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v37/*: any*/),
                                          (v44/*: any*/),
                                          (v82/*: any*/),
                                          (v84/*: any*/),
                                          (v85/*: any*/),
                                          (v89/*: any*/),
                                          (v91/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v75/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v140/*: any*/),
                                  (v139/*: any*/),
                                  (v119/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v74/*: any*/),
                                      (v121/*: any*/),
                                      (v122/*: any*/),
                                      (v123/*: any*/),
                                      (v80/*: any*/),
                                      (v64/*: any*/),
                                      (v43/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v126/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v153/*: any*/),
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "image",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "alt",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": (v109/*: any*/),
                                            "concreteType": "ImageStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": (v60/*: any*/),
                                            "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                                          }
                                        ],
                                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                                      }
                                    ],
                                    "type": "Video",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeMostPopular",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "mostPopularQueueQuery",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "mostPopularQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v155/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v44/*: any*/),
                                  (v147/*: any*/),
                                  (v107/*: any*/),
                                  (v70/*: any*/),
                                  (v69/*: any*/),
                                  (v73/*: any*/),
                                  (v65/*: any*/),
                                  (v136/*: any*/),
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  (v114/*: any*/),
                                  (v115/*: any*/),
                                  (v116/*: any*/),
                                  (v77/*: any*/),
                                  (v119/*: any*/),
                                  (v125/*: any*/),
                                  (v127/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:5)"
                  },
                  (v62/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeMultimedia",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "multimedia",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "multimediaQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v130/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v76/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v44/*: any*/),
                                  (v65/*: any*/),
                                  (v136/*: any*/),
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  (v140/*: any*/),
                                  (v139/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Image",
                                        "kind": "LinkedField",
                                        "name": "images",
                                        "plural": true,
                                        "selections": [
                                          (v37/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Gallery",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v82/*: any*/),
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v89/*: any*/),
                                      (v118/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleTypeSegment",
                                        "kind": "LinkedField",
                                        "name": "types",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ArticleType",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v35/*: any*/),
                                              (v58/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v140/*: any*/),
                                      (v124/*: any*/),
                                      (v64/*: any*/),
                                      (v156/*: any*/),
                                      (v43/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  (v127/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PodcastSection",
                                        "kind": "LinkedField",
                                        "name": "podcastSections",
                                        "plural": true,
                                        "selections": [
                                          (v156/*: any*/),
                                          (v36/*: any*/),
                                          (v62/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Podcast",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:4)"
                  },
                  (v62/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeTrendingTopics",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "trendingTopicsQueue",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "trendingTopicsQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v155/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v36/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v48/*: any*/),
                                      (v44/*: any*/),
                                      (v82/*: any*/),
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v89/*: any*/),
                                      (v91/*: any*/),
                                      (v102/*: any*/),
                                      (v103/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "type": "Topic",
                                "abstractKey": null
                              },
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:5)"
                  },
                  (v62/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includePlus",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "dailyPulseQuery",
                "args": [
                  {
                    "fields": [
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "typeIds.0",
                            "variableName": "dailyPulseTypeUuId"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "typeIds"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v144/*: any*/),
                  (v157/*: any*/)
                ],
                "concreteType": "ArticleConnection",
                "kind": "LinkedField",
                "name": "articles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v44/*: any*/),
                          (v62/*: any*/),
                          (v135/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v37/*: any*/),
                              (v75/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegment",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Section",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v36/*: any*/),
                                      (v62/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v139/*: any*/),
                              (v107/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v141/*: any*/),
                                  (v124/*: any*/),
                                  (v64/*: any*/),
                                  (v81/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "highlightQueue",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "highlightQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                      }
                    ],
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v44/*: any*/),
                                  (v65/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v59/*: any*/),
                                      (v108/*: any*/),
                                      (v67/*: any*/),
                                      (v111/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegment",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Section",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v36/*: any*/),
                                          (v62/*: any*/),
                                          (v113/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v139/*: any*/),
                                  (v119/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v81/*: any*/),
                                      (v122/*: any*/),
                                      (v124/*: any*/),
                                      (v64/*: any*/),
                                      (v43/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:2)"
                  },
                  (v62/*: any*/),
                  (v94/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v54/*: any*/),
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "endDate",
                            "variableName": "plusNewsAgendaEndDate"
                          },
                          {
                            "kind": "Variable",
                            "name": "startDate",
                            "variableName": "plusNewsAgendaStartDate"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "newsAgendaDateRange"
                      },
                      {
                        "kind": "Literal",
                        "name": "newsAgendaOptions",
                        "value": [
                          "key_event"
                        ]
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "plusNewsAgendaTypes"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  (v154/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "ASC",
                      "field": "NEWS_AGENDA_START_DATE"
                    }
                  }
                ],
                "concreteType": "TopicConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TopicEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewsAgenda",
                            "kind": "LinkedField",
                            "name": "newsAgenda",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "secondaryDescription",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "time",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newsAgendaOptions",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v58/*: any*/),
                          (v70/*: any*/),
                          (v62/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "scmp_pwa_settings"
                    }
                  }
                ],
                "concreteType": "AppConfig",
                "kind": "LinkedField",
                "name": "appConfig",
                "plural": false,
                "selections": [
                  (v98/*: any*/),
                  (v62/*: any*/)
                ],
                "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
              }
            ]
          },
          {
            "condition": "includeFocusArticle",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "focus",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "focusQueueName"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  {
                    "alias": null,
                    "args": (v145/*: any*/),
                    "concreteType": "QueueItemConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QueueItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v35/*: any*/),
                                  (v65/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v59/*: any*/),
                                      (v108/*: any*/),
                                      (v67/*: any*/),
                                      (v159/*: any*/),
                                      {
                                        "alias": "size640x360",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "wide_landscape_640_360"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v60/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v66/*: any*/),
                                  (v75/*: any*/),
                                  (v140/*: any*/),
                                  (v139/*: any*/),
                                  (v44/*: any*/),
                                  (v119/*: any*/),
                                  (v127/*: any*/),
                                  (v160/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": (v83/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegment",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Section",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v62/*: any*/),
                                          (v36/*: any*/),
                                          (v44/*: any*/),
                                          {
                                            "alias": null,
                                            "args": (v95/*: any*/),
                                            "concreteType": "Image",
                                            "kind": "LinkedField",
                                            "name": "image",
                                            "plural": false,
                                            "selections": (v96/*: any*/),
                                            "storageKey": "image(filter:{\"type\":\"TERM_LOGO\"})"
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v86/*: any*/),
                                  (v87/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v88/*: any*/)
                                ],
                                "type": "Video",
                                "abstractKey": null
                              },
                              (v92/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "items(first:1)"
                  },
                  (v62/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "includeOpenQuestionsSeriesDiscoveryWidget",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "openQuestionSeriesTopic",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "entityId": "518656"
                    }
                  }
                ],
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "paywallTypeIds",
                            "variableName": "scmpPlusPaywallTypeIds"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "exclude"
                      },
                      (v137/*: any*/),
                      (v157/*: any*/)
                    ],
                    "concreteType": "ContentConnection",
                    "kind": "LinkedField",
                    "name": "contents",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              (v62/*: any*/),
                              (v148/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v62/*: any*/)
                ],
                "storageKey": "topic(filter:{\"entityId\":\"518656\"})"
              }
            ]
          }
        ]
      },
      {
        "condition": "isStyleSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "topArticleQueue",
            "args": (v104/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v167/*: any*/),
            "storageKey": null
          },
          {
            "alias": "luxurySection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "322897"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v168/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"322897\"})"
          },
          {
            "alias": "luxuryArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_322897"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v170/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_322897\"})"
          },
          {
            "alias": "fashionSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516294"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v168/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516294\"})"
          },
          {
            "alias": "fashionArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516294"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v170/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
          },
          {
            "alias": "beautySection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516298"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v168/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516298\"})"
          },
          {
            "alias": "beautyArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516298"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v167/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
          },
          {
            "alias": "peopleSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516301"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v168/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516301\"})"
          },
          {
            "alias": "peopleArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516301"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v167/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
          },
          {
            "alias": "lifestyleSection",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "516305"
                }
              }
            ],
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v168/*: any*/),
            "storageKey": "section(filter:{\"entityId\":\"516305\"})"
          },
          {
            "alias": "lifestyleArticleQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "section_top_516305"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v167/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
          },
          {
            "alias": "fashionCarousel",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "style_fashion_carousel"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v171/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v65/*: any*/),
                              (v173/*: any*/),
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v140/*: any*/),
                              (v174/*: any*/),
                              (v175/*: any*/),
                              (v160/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"style_fashion_carousel\"})"
          },
          {
            "alias": "spotlight",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "4335"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v171/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v65/*: any*/),
                              (v173/*: any*/),
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v140/*: any*/),
                              (v139/*: any*/),
                              (v175/*: any*/),
                              (v160/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": "queue(filter:{\"entityId\":\"4335\"})"
          },
          {
            "alias": "styleVideoSectionPicksQueue",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "name": "video_section_picks_323289"
                }
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v145/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VideoSource",
                                "kind": "LinkedField",
                                "name": "videoSource",
                                "plural": true,
                                "selections": [
                                  (v62/*: any*/),
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v153/*: any*/),
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v158/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v60/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                                  }
                                ],
                                "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                              },
                              (v126/*: any*/)
                            ],
                            "type": "Video",
                            "abstractKey": null
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:1)"
              },
              (v62/*: any*/)
            ],
            "storageKey": "queue(filter:{\"name\":\"video_section_picks_323289\"})"
          }
        ]
      },
      {
        "condition": "isPostMagazineSection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "postMagSection",
            "args": (v146/*: any*/),
            "concreteType": "Section",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "subSections",
                "plural": false,
                "selections": [
                  (v93/*: any*/),
                  (v62/*: any*/)
                ],
                "storageKey": null
              },
              (v62/*: any*/)
            ],
            "storageKey": "section(filter:{\"entityId\":\"71\"})"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "entityId": "322743"
                }
              }
            ],
            "concreteType": "Newsletter",
            "kind": "LinkedField",
            "name": "newsletter",
            "plural": false,
            "selections": [
              (v58/*: any*/),
              (v71/*: any*/),
              (v62/*: any*/)
            ],
            "storageKey": "newsletter(filter:{\"entityId\":\"322743\"})"
          },
          {
            "alias": "leadStoryPostMagQueue",
            "args": (v104/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v138/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v44/*: any*/),
                              (v174/*: any*/),
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v59/*: any*/),
                                  (v108/*: any*/),
                                  (v67/*: any*/),
                                  (v110/*: any*/),
                                  (v176/*: any*/),
                                  (v111/*: any*/),
                                  (v172/*: any*/),
                                  (v163/*: any*/),
                                  (v112/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v140/*: any*/),
                              (v71/*: any*/),
                              (v119/*: any*/),
                              (v177/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sponsorQueue",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "sponsorQueueName"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v138/*: any*/),
                "concreteType": "QueueItemConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QueueItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v44/*: any*/),
                              (v174/*: any*/),
                              (v65/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v59/*: any*/),
                                  (v108/*: any*/),
                                  (v67/*: any*/),
                                  (v110/*: any*/),
                                  (v176/*: any*/),
                                  (v111/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*: any*/),
                              (v75/*: any*/),
                              (v140/*: any*/),
                              (v119/*: any*/),
                              (v177/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:6)"
              },
              (v62/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e27de2728f804e97c267a0b8dc8623d3",
    "id": null,
    "metadata": {},
    "name": "sectionPageQuery",
    "operationKind": "query",
    "text": "query sectionPageQuery(\n  $applicationId: String!\n  $articlesQueueName: String!\n  $commentQueueName: String!\n  $commentQueueLimit: Int!\n  $customContents: [CustomContentInput]\n  $dailyPulseTypeUuId: String!\n  $entityId: String!\n  $focusQueueName: String!\n  $highlightQueueName: String!\n  $isStyleSection: Boolean!\n  $isPostMagazineSection: Boolean!\n  $isSkipDefaultSectionQuery: Boolean!\n  $mostPopularQueueName: String!\n  $multimediaQueueName: String!\n  $plusNewsAgendaEndDate: Timestamp!\n  $plusNewsAgendaStartDate: Timestamp!\n  $plusNewsAgendaTypes: [String]!\n  $scmpPlusPaywallTypeIds: [String]\n  $sponsorQueueName: String!\n  $sectionSpotlightQueueName: String!\n  $trendingTopicsQueueName: String!\n  $includeAsiaDiscoveryWidget: Boolean!\n  $includeChinaFutureTechDiscoveryWidget: Boolean!\n  $includeChinaScienceDiscoveryWidget: Boolean!\n  $includeComment: Boolean!\n  $includeFocusArticle: Boolean!\n  $includeMostPopular: Boolean!\n  $includeMultimedia: Boolean!\n  $includeOpenQuestionsSeriesDiscoveryWidget: Boolean!\n  $includePlus: Boolean!\n  $includeThisWeekInAsiaDiscovery: Boolean!\n  $includeTrendingTopics: Boolean!\n) {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    name\n    ...hooksTrackCurrentItemBase_4oKxOH\n    ...contextsSectionContextProviderSection\n    ...sectionSeoSection\n    id\n  }\n  ...defaultSectionQuery_3HiAO1 @skip(if: $isSkipDefaultSectionQuery)\n  ...sectionStyleContentQuery_jhigl @include(if: $isStyleSection)\n  ...sectionPostMagazineQuery_GVfS0 @include(if: $isPostMagazineSection)\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleSeoArticle_3GTCBR on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents, type: PARAGRAPH) {\n    text\n  }\n  keywords\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  ...genericArticleSpeechInlineWidgetGenericArticle\n}\n\nfragment asiaDiscoveryWidgetQuery on Query {\n  asiaSection: section(filter: {entityId: \"3\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  asiaQueue: queue(filter: {name: \"section_top_3\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment atomsCurrentArticleAtomBase_3GTCBR on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...articleSeoArticle_3GTCBR\n    ...contentShareWidgetContent\n    ...headerContentBookmarkArticle\n    ...headerContentCommentTrigger\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...articleShareWidgetArticle\n    ...hooksTrackPageViewArticle\n    ...hooksContentInterestArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...hooksUseNotificationReadStatusArticle\n    ...onboardingNewsletterSubscriptionArticle\n  }\n}\n\nfragment atomsCurrentNotificationSectionAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    fullSectionPath {\n      ...hooksUseNotificationsSection\n      id\n    }\n  }\n  ... on Article {\n    sections {\n      value {\n        ...hooksUseNotificationsSection\n        id\n      }\n    }\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sections {\n      value {\n        entityId\n        name\n        id\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sections {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n  entityUuid\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    country\n    gender\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment chinaFutureTechDiscoveryWidgetQuery on Query {\n  chinaFutureTechSection: section(filter: {entityId: \"519735\"}) {\n    ...latestDiscoveryWidgetSection\n    ...sectionTermLogoSection\n    urlAlias\n    name\n    id\n  }\n  chinaFutureTechQueue: queue(filter: {name: \"section_top_519735\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment chinaScienceDiscoveryWidgetQuery on Query {\n  chinaScienceSection: section(filter: {entityId: \"328475\"}) {\n    ...latestDiscoveryWidgetSection\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment commentContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_2RX0zR\n  ... on Video {\n    headline\n    duration\n    image(filter: {type: MAIN_IMAGE}) {\n      alt\n      style(filter: {style: \"1200x800\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment commentQueueQuery_1samWO on Query {\n  commentSection: section(filter: {entityId: \"93\"}) {\n    urlAlias\n    ...followButtonBase\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: $commentQueueLimit) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...commentContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentAgendaContentTopic on Topic {\n  newsAgenda {\n    secondaryDescription\n  }\n  description {\n    text\n  }\n  updatedDate\n  name\n  ...hooksNewsAgendaTopic\n}\n\nfragment contentAuthorImageContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment contentAuthorLinkContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    entityUuid\n    name\n    ...entityLink\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment contentCoverImageContent_2HJhra on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2lKvrt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size800x1200: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_2vlzjQ on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34sBmM on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size800x1200: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_39yeLy on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3GPo97 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3c5f7Q on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1200x1200: style(filter: {style: \"1200x1200\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4m5j8 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4moPck on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_4x6KFd on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size500x500: style(filter: {style: \"500x500\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverVideoContent on Content {\n  __isContent: __typename\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n  flag\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment contextsSectionContextProviderSection on Section {\n  ...hooksUseSectionBaseAdvertisingInfoSection\n}\n\nfragment defaultSectionQuery_3HiAO1 on Query {\n  section(filter: {entityId: $entityId}) {\n    name\n    entityId\n    advertZone(version: 2)\n    subSections {\n      items {\n        edges {\n          ...entityOnelineMenuLiteQueueItemsEdge\n        }\n      }\n      settings\n      id\n    }\n    ...sectionTermLogoSection\n    ...sectionDescriptionSection\n    ...entityFollowButtonBase\n    id\n  }\n  topStories: queue(filter: {name: $articlesQueueName}) {\n    items(first: 17) {\n      edges {\n        ...oneSectionTopWidgetQueue\n        ...topStoriesBlockQueueItemsEdge\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  spotlightQueue: queue(filter: {name: $sectionSpotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  commentQueue: queue(filter: {name: $commentQueueName}) {\n    items(first: $commentQueueLimit) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  asiaQueue: queue(filter: {name: \"section_top_3\"}) @include(if: $includeAsiaDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  chinaFutureTechQueue: queue(filter: {name: \"section_top_519735\"}) @include(if: $includeChinaFutureTechDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  chinaScienceQueue: queue(filter: {name: \"section_top_328475\"}) @include(if: $includeChinaScienceDiscoveryWidget) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  twiaQueue: queue(filter: {name: \"section_top_323045\"}) @include(if: $includeThisWeekInAsiaDiscovery) {\n    items(first: 6) {\n      edges {\n        ...contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge\n      }\n    }\n    id\n  }\n  ...sectionNewsletterWidgetQuery_49mQWb\n  ...sectionSpotlightQuery_S3w6I\n  ...hooksSectionWidgetQuery_43OK7R\n}\n\nfragment discoveryWidgetPostMagazineQueueQuery on Query {\n  postMagazineLast7Days: queue(filter: {name: \"scmp_trending_section_scmp_trending_section_postmag_last_7_days\"}) {\n    items(first: 6) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSponsor: queue(filter: {name: \"discovery_module_discovery_module_71\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            ...postMagazineDiscoveryItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  postMagazineSection: section(filter: {entityId: \"71\"}) {\n    ...entityLink\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityOnelineMenuLiteQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment entityOnelineMenuQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Topic {\n      name\n      urlAlias\n    }\n    ... on Section {\n      name\n      urlAlias\n      urlRedirect {\n        toUrl\n        id\n      }\n    }\n    ...entityLink\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment focusArticleHomeFocusArticleQuery_4COOKT on Query {\n  focus: queue(filter: {name: $focusQueueName}) {\n    settings\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ...homeFocusContentItemContent\n          ...helpersGetArticleTitleArticle\n          ...helpersGetPodcastTitlePodcast\n          ...helpersGetVideoTitleVideo\n          ...helpersCheckIsLiveArticle\n          ...helpersGetArticleLogoArticle\n          ... on Content {\n            __isContent: __typename\n            entityId\n            urlAlias\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  articleSpeeches {\n    url\n  }\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n}\n\nfragment headerContentBookmarkArticle on Article {\n  entityId\n}\n\nfragment headerContentCommentTrigger on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment headerPostMagazineQuery on Query {\n  postMagSection: section(filter: {entityId: \"71\"}) {\n    urlAlias\n    subSections {\n      items {\n        edges {\n          ...entityOnelineMenuQueueItemsEdge\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleLogoArticle on Article {\n  sections {\n    value {\n      entityId\n      name\n      urlAlias\n      image(filter: {type: TERM_LOGO}) {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTitleArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetLabelContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n    sections {\n      value {\n        name\n        id\n      }\n    }\n  }\n  ... on Gallery {\n    __typename\n  }\n  ... on Video {\n    __typename\n  }\n}\n\nfragment helpersGetPodcastTitlePodcast on Podcast {\n  __typename\n}\n\nfragment helpersGetVideoTitleVideo on Video {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment homeFocusContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  entityId\n  ... on Video {\n    duration\n  }\n  ...hooksContentItemProvidersContent_Q7hCx\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3KFgji\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_debate\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Article {\n  entityId\n  sentiment\n  urlAlias\n  types {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksContentItemProvidersContent_14w7Xi on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentReadingTimeContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1YIyJs on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3GPo97\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1aiv1W on Content {\n  __isContent: __typename\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2Mm1vQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4moPck\n  ...contentHeadlineContent\n  ...contentSectionsContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2RX0zR on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentAuthorImageContent\n  ...contentAuthorLinkContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2zd4GF on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2lKvrt\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3KFgji on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3SIuYu on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3hlRa7 on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_34sBmM\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3k6QDo on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2lKvrt\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_4hutWY on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3c5f7Q\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_9hDaW on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_39yeLy\n  ...contentHeadlineContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_JIVKo on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4x6KFd\n  ...contentCoverVideoContent\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_Q7hCx on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_4m5j8\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_gwnn5 on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2HJhra\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksNewsAgendaTopic on Topic {\n  newsAgenda {\n    startDate\n    endDate\n    time\n    newsAgendaOptions\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksPlusArticleLinkHandlerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  id\n  entityId\n  urlAlias\n}\n\nfragment hooksPlusWidgetConfigQuery on Query {\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n    id\n  }\n}\n\nfragment hooksSectionWidgetQuery_43OK7R on Query {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  ...thisWeekInAsiaDiscoveryWidgetQuery @include(if: $includeThisWeekInAsiaDiscovery)\n  ...commentQueueQuery_1samWO @include(if: $includeComment)\n  ...discoveryWidgetPostMagazineQueueQuery\n  ...mostPopularQueueQuery_KkbCb @include(if: $includeMostPopular)\n  ...multimediaQuery_4rBIay @include(if: $includeMultimedia)\n  ...trendingTopicTopic_4tMn4o @include(if: $includeTrendingTopics)\n  ...plusWidgetQuery_1YyBVf @include(if: $includePlus)\n  ...asiaDiscoveryWidgetQuery @include(if: $includeAsiaDiscoveryWidget)\n  ...chinaScienceDiscoveryWidgetQuery @include(if: $includeChinaScienceDiscoveryWidget)\n  ...chinaFutureTechDiscoveryWidgetQuery @include(if: $includeChinaFutureTechDiscoveryWidget)\n  ...focusArticleHomeFocusArticleQuery_4COOKT @include(if: $includeFocusArticle)\n  ...openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo @include(if: $includeOpenQuestionsSeriesDiscoveryWidget)\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase_4oKxOH on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3GTCBR\n  ...atomsCurrentNotificationSectionAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Article {\n  entityId\n  publishedDate\n  headline\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Article {\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUseDeepLinkTagsBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  urlAlias\n  entityId\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment hooksUseNotificationReadStatusArticle on Article {\n  entityId\n}\n\nfragment hooksUseNotificationsSection on Section {\n  ...notificationSection\n  entityId\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment hooksUseSectionBaseAdvertisingInfoSection on Section {\n  advertZone(version: 2)\n  entityId\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment itemAgendaItemTopic on Topic {\n  urlAlias\n  newsAgenda {\n    startDate\n  }\n  entityId\n  name\n  ...contentAgendaContentTopic\n  ...hooksNewsAgendaTopic\n}\n\nfragment latestDiscoveryWidgetQueue on Queue {\n  items(first: 6) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          entityId\n          ...homeSecondaryContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment latestDiscoveryWidgetSection on Section {\n  urlAlias\n  name\n  entityId\n  parentSection\n}\n\nfragment leadStoryPostMagazineContent on Content {\n  __isContent: __typename\n  ...postMagazineLeadContentItemContent\n}\n\nfragment magazinesStyleCardContentItemContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    ...topicLinkTopic\n    id\n  }\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_4hutWY\n}\n\nfragment magazinesStyleFashionCarouselContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksContentItemProvidersContent_2zd4GF\n}\n\nfragment magazinesStyleLeadContentItemContent on Content {\n  __isContent: __typename\n  authors {\n    ...authorNameAuthor\n    id\n  }\n  ...entityLink\n  ...helpersIsArticleVideoAsHeroArticle\n  ...hooksContentItemProvidersContent_JIVKo\n}\n\nfragment magazinesStyleSpotlightContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ... on Article {\n    sections {\n      value {\n        name\n        id\n      }\n    }\n  }\n  ...hooksContentItemProvidersContent_3k6QDo\n}\n\nfragment mostPopularQueueQuery_KkbCb on Query {\n  mostPopularQueueQuery: queue(filter: {name: $mostPopularQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment multimediaContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Gallery {\n    images {\n      __typename\n    }\n  }\n  ...entityLink\n  ...helpersGetLabelContent\n  ...hooksContentItemProvidersContent_3SIuYu\n}\n\nfragment multimediaPodcastContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    images {\n      style(filter: {style: \"100x100\"}) {\n        url\n      }\n    }\n  }\n  ... on Podcast {\n    podcastSections {\n      images {\n        style(filter: {style: \"100x100\"}) {\n          url\n        }\n      }\n      name\n      id\n    }\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_1aiv1W\n}\n\nfragment multimediaQuery_4rBIay on Query {\n  multimedia: queue(filter: {name: $multimediaQueueName}) {\n    items(first: 4) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            types {\n              value {\n                name\n                id\n              }\n            }\n          }\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...multimediaContentItemContent\n            ...multimediaPodcastContentItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment notificationSection on Section {\n  name\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment onePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazinePrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment onePostMagSectionTopWidgetSponsorQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazinePrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment oneSectionTopWidgetQueue on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...homeSecondaryContentItemContent\n      ...sectionTopLeadPrimaryContentItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment openQuestionsSeriesDiscoveryWidgetQuery_2uEaAo on Query {\n  openQuestionSeriesTopic: topic(filter: {entityId: \"518656\"}) {\n    name\n    urlAlias\n    contents(exclude: {paywallTypeIds: $scmpPlusPaywallTypeIds}, first: 6, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...homeSecondaryContentItemContent\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusWidgetDailyPulseQuery_3abQBm on Query {\n  dailyPulseQuery: articles(filter: {typeIds: [$dailyPulseTypeUuId]}, first: 1, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        urlAlias\n        ...entityLink\n        ...contentHeadlineContent\n        ...hooksArticleDateUtilsContent\n        ...hooksPlusArticleLinkHandlerArticle\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetHasAccessQuery_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment plusWidgetHighlight on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksContentItemProvidersContent_2Mm1vQ\n  ...plusArticleTypeTitleContent\n}\n\nfragment plusWidgetHighlightsQuery_3iQMXB on Query {\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    items(first: 2) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityId\n            ...plusWidgetHighlight\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment plusWidgetNewsAgendaQuery_3kWRW2 on Query {\n  topics(first: 5, applicationId: $applicationId, filter: {types: $plusNewsAgendaTypes, newsAgendaDateRange: {startDate: $plusNewsAgendaStartDate, endDate: $plusNewsAgendaEndDate}, newsAgendaOptions: [\"key_event\"]}, orderBy: {field: NEWS_AGENDA_START_DATE, direction: ASC}) {\n    edges {\n      node {\n        ...itemAgendaItemTopic\n        ...hooksNewsAgendaTopic\n        newsAgenda {\n          newsAgendaOptions\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment plusWidgetQuery_1YyBVf on Query {\n  ...plusWidgetWithoutAccess_1YyBVf\n  ...plusWidgetHasAccessQuery_1YyBVf\n  ...hooksPlusWidgetConfigQuery\n}\n\nfragment plusWidgetWithoutAccess_1YyBVf on Query {\n  ...plusWidgetDailyPulseQuery_3abQBm\n  ...plusWidgetHighlightsQuery_3iQMXB\n  ...plusWidgetNewsAgendaQuery_3kWRW2\n  highlightQueue: queue(filter: {name: $highlightQueueName}) {\n    settings\n    id\n  }\n}\n\nfragment postMagazineDiscoveryItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...articleCommentArticle\n  ...entityLink\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_14w7Xi\n}\n\nfragment postMagazineLeadContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_gwnn5\n}\n\nfragment postMagazineNewsletter on Query {\n  newsletter(filter: {entityId: \"322743\"}) {\n    description {\n      text\n    }\n    summary {\n      text\n    }\n    id\n  }\n}\n\nfragment postMagazinePrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_9hDaW\n}\n\nfragment postMagazineSectionWidgetThreeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_1YIyJs\n}\n\nfragment postMagazineSectionWidgetTwoContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...hooksContentItemProvidersContent_3hlRa7\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionDescriptionSection on Section {\n  description {\n    text\n    json\n  }\n}\n\nfragment sectionNewsletterWidgetQuery_49mQWb on Query {\n  section(filter: {entityId: $entityId}) {\n    entityId\n    id\n  }\n}\n\nfragment sectionPostMagazineQuery_GVfS0 on Query {\n  ...headerPostMagazineQuery\n  ...postMagazineNewsletter\n  section(filter: {entityId: $entityId}) {\n    entityId\n    advertZone(version: 2)\n    id\n  }\n  leadStoryPostMagQueue: queue(filter: {name: $articlesQueueName}) {\n    items(first: 6) {\n      edges {\n        ...onePostMagSectionTopWidgetArticles\n        ...twoPostMagSectionTopWidgetArticles\n        ...threePostMagSectionTopWidgetArticles\n        node {\n          __typename\n          ...leadStoryPostMagazineContent\n          ... on Content {\n            __isContent: __typename\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  sponsorQueue: queue(filter: {name: $sponsorQueueName}) {\n    items(first: 6) {\n      edges {\n        ...onePostMagSectionTopWidgetSponsorQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionSeoSection on Section {\n  name\n  description {\n    text\n  }\n  entityId\n  entityUuid\n  image(filter: {type: OG}) {\n    url\n  }\n  parentSection\n  urlAlias\n  ...hooksUseDeepLinkTagsBase\n  ...hooksUseDynamicMetaTags\n}\n\nfragment sectionSpotlightQuery_S3w6I on Query {\n  sectionSpotlightQueue: queue(filter: {name: $sectionSpotlightQueueName}) {\n    items(first: 4) {\n      edges {\n        ...topStoriesBlockQueueItemsEdge\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleContentQuery_jhigl on Query {\n  ...sectionStyleMainQuery_jhigl\n}\n\nfragment sectionStyleFashionCarouselQuery on Query {\n  fashionCarousel: queue(filter: {name: \"style_fashion_carousel\"}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on BaseWithApplicationAndUrlAlias {\n            __isBaseWithApplicationAndUrlAlias: __typename\n            entityId\n          }\n          ...magazinesStyleFashionCarouselContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleMainArticleListQueue_3z2gQm on Queue {\n  items(first: 4, exclude: {types: VIDEO}) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          ...magazinesStyleLeadContentItemContent\n          ...magazinesStyleCardContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment sectionStyleMainArticleListQueue_4yQIxA on Queue {\n  items(first: 3, exclude: {types: VIDEO}) {\n    edges {\n      node {\n        __typename\n        ... on Article {\n          ...magazinesStyleLeadContentItemContent\n          ...magazinesStyleCardContentItemContent\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment sectionStyleMainArticleListSection on Section {\n  ...sectionStyleSectionSection\n}\n\nfragment sectionStyleMainQuery_jhigl on Query {\n  topArticleQueue: queue(filter: {name: $articlesQueueName}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  luxurySection: section(filter: {entityId: \"322897\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  luxuryArticleQueue: queue(filter: {name: \"section_top_322897\"}) {\n    ...sectionStyleMainArticleListQueue_3z2gQm\n    id\n  }\n  fashionSection: section(filter: {entityId: \"516294\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  fashionArticleQueue: queue(filter: {name: \"section_top_516294\"}) {\n    ...sectionStyleMainArticleListQueue_3z2gQm\n    id\n  }\n  beautySection: section(filter: {entityId: \"516298\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  beautyArticleQueue: queue(filter: {name: \"section_top_516298\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  peopleSection: section(filter: {entityId: \"516301\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  peopleArticleQueue: queue(filter: {name: \"section_top_516301\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  lifestyleSection: section(filter: {entityId: \"516305\"}) {\n    ...sectionStyleMainArticleListSection\n    id\n  }\n  lifestyleArticleQueue: queue(filter: {name: \"section_top_516305\"}) {\n    ...sectionStyleMainArticleListQueue_4yQIxA\n    id\n  }\n  ...sectionStyleFashionCarouselQuery\n  ...sectionStyleSpotlightQuery\n  ...sectionStyleVideoWidgetQuery\n}\n\nfragment sectionStyleSectionSection on Section {\n  name\n  images(filter: {type: {values: [\"logo\"]}}) {\n    url\n  }\n  ...entityLink\n}\n\nfragment sectionStyleSpotlightQuery on Query {\n  spotlight: queue(filter: {entityId: \"4335\"}) {\n    items {\n      edges {\n        node {\n          __typename\n          ... on BaseWithApplicationAndUrlAlias {\n            __isBaseWithApplicationAndUrlAlias: __typename\n            entityId\n          }\n          ...magazinesStyleSpotlightContentItemContent\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionStyleVideoWidgetQuery on Query {\n  styleVideoSectionPicksQueue: queue(filter: {name: \"video_section_picks_323289\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            entityId\n            headline\n            socialHeadline\n            videoSource {\n              id\n              type\n            }\n            image(filter: {type: MAIN_IMAGE}) {\n              style(filter: {style: \"wide_landscape\"}) {\n                url\n              }\n            }\n            duration\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment sectionTermLogoSection on Section {\n  name\n  sectionLogo: image(filter: {type: TERM_LOGO}) {\n    style(filter: {style: \"100x100\"}) {\n      url\n    }\n  }\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment thisWeekInAsiaDiscoveryWidgetQuery on Query {\n  twiaSection: section(filter: {entityId: \"323045\"}) {\n    ...latestDiscoveryWidgetSection\n    ...sectionTermLogoSection\n    urlAlias\n    name\n    id\n  }\n  twiaQueue: queue(filter: {name: \"section_top_323045\"}) {\n    ...latestDiscoveryWidgetQueue\n    id\n  }\n}\n\nfragment threePostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetThreeContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topStoriesBlockQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...topStoriesItemContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment trendingTopicTopic_4tMn4o on Query {\n  trendingTopicsQueue: queue(filter: {name: $trendingTopicsQueueName}) {\n    items(first: 5) {\n      edges {\n        node {\n          __typename\n          ... on Topic {\n            ...entityLink\n            ...followButtonBase\n            name\n            entityId\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment twoPostMagSectionTopWidgetArticles on QueueItemsEdge {\n  node {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...postMagazineSectionWidgetTwoContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0c03dd0fa522189788eefc808b48b44";

export default node;
